import type { ISerialize } from '@/objects/ISerialize';
import type { Gender } from './../enums/Gender';

export class ContestantImportRelayContestant implements ISerialize {
    public Birthday: string | null;

    public BirthdayNormalized: string | null;

    public Cellphone: string | null;

    public ContestantStatusID: number | null;

    public CountryId: string | null;

    public Email: string | null;

    public Firstname: string | null;

    public Gender: string | null;

    public GenderNormalized: Gender | null;

    public Nationality: string | null;

    public NationalityNormalized: number | null;

    public PostAddress1: string | null;

    public PostAddress2: string | null;

    public PostCity: string | null;

    public PostZipCode: string | null;

    public SourceClubId: number | null;

    public SourceContestantId: number | null;

    public SourceParticipantId: number | null;

    public SourceTeamId: number | null;

    public Surname: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        Birthday?: string | null;
        BirthdayNormalized?: string | null;
        Cellphone?: string | null;
        ContestantStatusID?: number | null;
        CountryId?: string | null;
        Email?: string | null;
        Firstname?: string | null;
        Gender?: string | null;
        GenderNormalized?: Gender | null;
        Nationality?: string | null;
        NationalityNormalized?: number | null;
        PostAddress1?: string | null;
        PostAddress2?: string | null;
        PostCity?: string | null;
        PostZipCode?: string | null;
        SourceClubId?: number | null;
        SourceContestantId?: number | null;
        SourceParticipantId?: number | null;
        SourceTeamId?: number | null;
        Surname?: string | null;
    }) {
        this.Birthday = values.Birthday ?? '';

        this.BirthdayNormalized = values.BirthdayNormalized ?? null;

        this.Cellphone = values.Cellphone ?? '';

        this.ContestantStatusID = values.ContestantStatusID ?? null;

        this.CountryId = values.CountryId ?? '';

        this.Email = values.Email ?? '';

        this.Firstname = values.Firstname ?? '';

        this.Gender = values.Gender ?? '';

        this.GenderNormalized = values.GenderNormalized ?? 'm';

        this.Nationality = values.Nationality ?? '';

        this.NationalityNormalized = values.NationalityNormalized ?? null;

        this.PostAddress1 = values.PostAddress1 ?? '';

        this.PostAddress2 = values.PostAddress2 ?? '';

        this.PostCity = values.PostCity ?? '';

        this.PostZipCode = values.PostZipCode ?? '';

        this.SourceClubId = values.SourceClubId ?? null;

        this.SourceContestantId = values.SourceContestantId ?? null;

        this.SourceParticipantId = values.SourceParticipantId ?? null;

        this.SourceTeamId = values.SourceTeamId ?? null;

        this.Surname = values.Surname ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"Birthday": ${JSON.stringify(this.Birthday)}` +
            ',' +
            `"BirthdayNormalized": ${JSON.stringify(this.BirthdayNormalized)}` +
            ',' +
            `"Cellphone": ${JSON.stringify(this.Cellphone)}` +
            ',' +
            `"ContestantStatusID": ${JSON.stringify(this.ContestantStatusID)}` +
            ',' +
            `"CountryId": ${JSON.stringify(this.CountryId)}` +
            ',' +
            `"Email": ${JSON.stringify(this.Email)}` +
            ',' +
            `"Firstname": ${JSON.stringify(this.Firstname)}` +
            ',' +
            `"Gender": ${JSON.stringify(this.Gender)}` +
            ',' +
            `"GenderNormalized": ${this.GenderNormalized == null ? null : this.GenderNormalized == 'm' ? 0 : this.GenderNormalized == 'f' ? 1 : this.GenderNormalized == 'n' ? 2 : null}` +
            ',' +
            `"Nationality": ${JSON.stringify(this.Nationality)}` +
            ',' +
            `"NationalityNormalized": ${JSON.stringify(this.NationalityNormalized)}` +
            ',' +
            `"PostAddress1": ${JSON.stringify(this.PostAddress1)}` +
            ',' +
            `"PostAddress2": ${JSON.stringify(this.PostAddress2)}` +
            ',' +
            `"PostCity": ${JSON.stringify(this.PostCity)}` +
            ',' +
            `"PostZipCode": ${JSON.stringify(this.PostZipCode)}` +
            ',' +
            `"SourceClubId": ${JSON.stringify(this.SourceClubId)}` +
            ',' +
            `"SourceContestantId": ${JSON.stringify(this.SourceContestantId)}` +
            ',' +
            `"SourceParticipantId": ${JSON.stringify(this.SourceParticipantId)}` +
            ',' +
            `"SourceTeamId": ${JSON.stringify(this.SourceTeamId)}` +
            ',' +
            `"Surname": ${JSON.stringify(this.Surname)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ContestantImportRelayContestant from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Birthday?: string | null;
        BirthdayNormalized?: string | null;
        Cellphone?: string | null;
        ContestantStatusID?: number | null;
        CountryId?: string | null;
        Email?: string | null;
        Firstname?: string | null;
        Gender?: string | null;
        GenderNormalized?: Gender | null;
        Nationality?: string | null;
        NationalityNormalized?: number | null;
        PostAddress1?: string | null;
        PostAddress2?: string | null;
        PostCity?: string | null;
        PostZipCode?: string | null;
        SourceClubId?: number | null;
        SourceContestantId?: number | null;
        SourceParticipantId?: number | null;
        SourceTeamId?: number | null;
        Surname?: string | null;
    }): ContestantImportRelayContestant {
        return new ContestantImportRelayContestant(values);
    }

    public static _FromServerJson(json: any): ContestantImportRelayContestant {
        return new ContestantImportRelayContestant({
            Birthday: json.Birthday ?? '',
            BirthdayNormalized: json.BirthdayNormalized ?? '',
            Cellphone: json.Cellphone ?? '',
            ContestantStatusID: json.ContestantStatusID ?? null,
            CountryId: json.CountryId ?? '',
            Email: json.Email ?? '',
            Firstname: json.Firstname ?? '',
            Gender: json.Gender ?? '',
            GenderNormalized:
                json.GenderNormalized == null
                    ? null
                    : json.GenderNormalized == 0
                      ? 'm'
                      : json.GenderNormalized == 1
                        ? 'f'
                        : json.GenderNormalized == 2
                          ? 'n'
                          : null,
            Nationality: json.Nationality ?? '',
            NationalityNormalized: json.NationalityNormalized ?? null,
            PostAddress1: json.PostAddress1 ?? '',
            PostAddress2: json.PostAddress2 ?? '',
            PostCity: json.PostCity ?? '',
            PostZipCode: json.PostZipCode ?? '',
            SourceClubId: json.SourceClubId ?? null,
            SourceContestantId: json.SourceContestantId ?? null,
            SourceParticipantId: json.SourceParticipantId ?? null,
            SourceTeamId: json.SourceTeamId ?? null,
            Surname: json.Surname ?? '',
        });
    }

    /**
     * Creates an instance of ContestantImportRelayContestant from another instance of ContestantImportRelayContestant.
     * @param other The ContestantImportRelayContestant you want to clone
     * @returns A cloned ContestantImportRelayContestant
     */
    public static FromOther(other: ContestantImportRelayContestant): ContestantImportRelayContestant {
        return ContestantImportRelayContestant._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ContestantImportRelayContestant.FromOther(this);
    }

    static NAME_OF_CLASS = 'ContestantImportRelayContestant';
}
